import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {BenjiKIV} from "../../../BenjiKIV";
import {BenjiKIVOverlayScatterSymbol} from "../../../reels/BenjiKIVOverlayScatterSymbol";
import {gsap} from "gsap";
import {BenjiKIVStatics} from "../../../BenjiKIVStatics";
import {MathHelper} from "@nolimitcity/slot-game/bin/utils/MathHelper";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {BenjiKIVGameMode} from "../../../server/BenjiKIVGameMode";
import {BenjiKIVSound} from "../../../sound/BenjiKIVSound";
import {BenjiKIVGameData} from "../../../server/BenjiKIVData";


/**
 * Created by Jerker Nord on 2022-12-01.
 */

export class BenjiKIVOverlayScatterView extends PIXI.Container implements StageLayer {

    private _activeOverlayScatters:BenjiKIVOverlayScatterSymbol[];
    private _noEndRandomAnimationTL:gsap.core.Timeline;
    private _activateBoostedOverlaysTL:gsap.core.Timeline;
    private _randomAnimationDuration:number;
    private _stopNoEndAnimation:boolean;
    private _randomPositions:PIXI.Point[];
    private _boostedActivated:boolean = false;

    constructor() {
        super();
        this.name = "BenjiKIVOverlayScatterView";
        this._activeOverlayScatters = [];
        this.position = BenjiKIVStatics.MAIN_REELS_VIEW_POSITION;

        if(BenjiKIV.model.isRestore == true && (
            BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN
            || BenjiKIV.model.data.mode == BenjiKIVGameMode.SUPER_FREESPIN
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL_EXTRA_SPIN && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN))) {
            this.activateAllScatters();
        }

        this._activateBoostedOverlaysTL = gsap.timeline({paused : true});
        this._activateBoostedOverlaysTL.add(() => this.doNoEndRandomAnimation(), "+=0.8");
    }

    //This will activate two random positioned overlays
    public activateBoostedOverlays():void {
        //If restore it's handled in the constructor
        //If we have overlays on the reels, do nothing
        if(this._activeOverlayScatters.length > 0) {
            return;
        }
        this._boostedActivated = true;
        if(this._activateBoostedOverlaysTL && this._activateBoostedOverlaysTL.isActive()) {
            this._activateBoostedOverlaysTL.pause();
        }
        if(this._noEndRandomAnimationTL && this._noEndRandomAnimationTL.isActive()) {
            this._stopNoEndAnimation = true;
            this._noEndRandomAnimationTL.pause();
            this._noEndRandomAnimationTL.kill();
            this.getHideAllOverlays();
        }
        const randomPos:PIXI.Point[] = [];
        const randomPos1:number = MathHelper.randomIntInRange(0, 14);
        let randomPos2:number = MathHelper.randomIntInRange(0, 14);
        while(randomPos2 == randomPos1) {
            randomPos2 = MathHelper.randomIntInRange(0, 14);
        }
        randomPos.push(BenjiKIV.model.getScatterReelAndRowPosition(randomPos1));
        randomPos.push(BenjiKIV.model.getScatterReelAndRowPosition(randomPos2));
        BenjiKIV.soundPlayer.playSound(BenjiKIVSound.SCATTER_INIT);
        for(let i:number = 0; i < randomPos.length; i++) {
            const overlayScatter:BenjiKIVOverlayScatterSymbol = BenjiKIV.overlayScatterPool.getOverlayScatter();
            this.addChild(overlayScatter);
            overlayScatter.index = this._activeOverlayScatters.length + 2;
            overlayScatter.initMultiplier(2 + this._activeOverlayScatters.length);
            overlayScatter.position.x = randomPos[i].x * BenjiKIVStatics.symbolWidth;
            overlayScatter.position.y = (randomPos[i].y + 2) * BenjiKIVStatics.symbolHeight;
            overlayScatter.overlayPosition.x = randomPos[i].x;
            overlayScatter.overlayPosition.y = randomPos[i].y;
            overlayScatter.visible = true;
            overlayScatter.getInitAnimation();
            this._activeOverlayScatters.push(overlayScatter);
        }
        this._stopNoEndAnimation = false;
        this._activateBoostedOverlaysTL.restart();
    }
    public actionSpinsCreateScatters(response:BenjiKIVGameData):gsap.core.Timeline{
        const tl:gsap.core.Timeline= new gsap.core.Timeline();
        for(let i:number = 0; i < response.overlayScatter.length; i++) {
            const val:number=response.overlayScatter[i],
                reelId:number=Number(String(val/3)[0]),
                rowId:number=val%3;
            if(response.evaluatedArea[reelId][rowId]==="S"){
                continue;
            }
            const pos:PIXI.Point=BenjiKIV.model.getScatterReelAndRowPosition(response.overlayScatter[i]);
            const overlayScatter:BenjiKIVOverlayScatterSymbol = BenjiKIV.overlayScatterPool.getOverlayScatter();
            this.addChild(overlayScatter);
            overlayScatter.index = this._activeOverlayScatters.length + 2;
            overlayScatter.initMultiplier(response.multiplierScatters[i]);
            overlayScatter.position.x = pos.x * BenjiKIVStatics.symbolWidth;
            overlayScatter.position.y = (pos.y + 2) * BenjiKIVStatics.symbolHeight;
            overlayScatter.overlayPosition.x = pos.x;
            overlayScatter.overlayPosition.y = pos.y;
            overlayScatter.visible = true;
            tl.add(overlayScatter.getInitAnimation());
            this._activeOverlayScatters.push(overlayScatter);
        }
        return tl.progress(1);
    }

    public deActivateBoostedOverlays(calledFromASPromoPanel:boolean=false):void {
        if(calledFromASPromoPanel){
            this._stopNoEndAnimation = true;
            if(this._activateBoostedOverlaysTL){
                this._activateBoostedOverlaysTL.pause();
            }
            if(this._noEndRandomAnimationTL){
                this._noEndRandomAnimationTL.pause();
                this._noEndRandomAnimationTL.kill();
            }
            this.getHideAllOverlays().progress(1);
            return;
        }
        if(this._activateBoostedOverlaysTL && this._activateBoostedOverlaysTL.isActive()) {
            this._activateBoostedOverlaysTL.pause();
            calledFromASPromoPanel?this.getHideAllOverlays().progress(1):this.getHideAllOverlays();
        } else if(this._noEndRandomAnimationTL && this._noEndRandomAnimationTL.isActive()) {
            this._stopNoEndAnimation = true;
            this._noEndRandomAnimationTL.pause();
            this._noEndRandomAnimationTL.kill();
            calledFromASPromoPanel?this.getHideAllOverlays().progress(1):this.getHideAllOverlays();
        }
        if(BenjiKIV.model.betWayWins && BenjiKIV.model.betWayWins.length == 0) {
            calledFromASPromoPanel?this.getHideAllOverlays().progress(1):this.getHideAllOverlays();
        }
    }

    public checkOverlayOnTopOfMultiplier(reelId:number, row:number):gsap.core.Timeline {
        for(let i:number = 0; i < this._activeOverlayScatters.length; i++) {
            if(this._activeOverlayScatters[i].overlayPosition.x == reelId && this._activeOverlayScatters[i].overlayPosition.y == row) {
                return this._activeOverlayScatters[i].getMakeRoomAnimation();
            }
        }
        return gsap.timeline();
    }

    public activateAllScatters(forceRestore:boolean = false):gsap.core.Timeline {
        if((BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.FREESPIN)
            || (BenjiKIV.model.data.mode == BenjiKIVGameMode.NORMAL && BenjiKIV.model.data.nextMode == BenjiKIVGameMode.SUPER_FREESPIN)
            || BenjiKIV.model.isRestore == true) {
            this._activeOverlayScatters = [];
        }
        const tl:gsap.core.Timeline = gsap.timeline();
        tl.add(() => {
            let positions:PIXI.Point[];
            if(BenjiKIV.model.isRestore == true || forceRestore == true) {
                if(forceRestore == true) {
                    tl.add(this.getHideAllOverlays());
                }
                positions = BenjiKIV.model.parsedTargetScatterPositions;
            } else {
                positions = BenjiKIV.model.getAllScatterPositions();
            }
            let initSoundPlayed:boolean = false;
            for(let i:number = 0; i < positions.length; i++) {
                const overlayScatter:BenjiKIVOverlayScatterSymbol = BenjiKIV.overlayScatterPool.getOverlayScatter();
                this.addChild(overlayScatter);
                overlayScatter.index = this._activeOverlayScatters.length + 2;
                if(BenjiKIV.model.isRestore == true) {
                    overlayScatter.initMultiplier(BenjiKIV.model.multiplierScatters[i]);
                } else {
                    overlayScatter.initMultiplier(this._activeOverlayScatters.length + 2);
                }
                overlayScatter.position.x = positions[i].x * BenjiKIVStatics.symbolWidth;
                overlayScatter.position.y = (positions[i].y + 2) * BenjiKIVStatics.symbolHeight;
                overlayScatter.overlayPosition.x = positions[i].x;
                overlayScatter.overlayPosition.y = (positions[i].y + 2);
                overlayScatter.visible = true;
                if(initSoundPlayed == false) {
                    initSoundPlayed = true;
                    BenjiKIV.soundPlayer.playSound(BenjiKIVSound.SCATTER_INIT);
                }
                overlayScatter.getInitAnimation();
                this._activeOverlayScatters.push(overlayScatter);
            }
        });

        return tl;
    }

    public restoreAllMakeRoomOverlays():void {
        for(let i:number = 0; i < this._activeOverlayScatters.length; i++) {
            this._activeOverlayScatters[i].getARoomAnimation();
        }
    }

    //Move scatter around minimum scatter random time
    public getAnimateAllRandomTL():gsap.core.Timeline {
        //Return random TL with minimum random ani time, then keep animating until stopped by getAnimateAllToTargetTL()
        if(this._noEndRandomAnimationTL && this._noEndRandomAnimationTL.isActive()) {
            this._noEndRandomAnimationTL.pause();
            this._noEndRandomAnimationTL.kill();
        }
        this._randomAnimationDuration = 0.4;
        this._stopNoEndAnimation = false;
        let sweepSoundPlayed:boolean;
        const mainRandomTL:gsap.core.Timeline = gsap.timeline();
        let moves:number = BenjiKIV.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? BenjiKIVStatics.SCATTER_OVERLAY_RANDOM_POSITIONS_FAST : BenjiKIVStatics.SCATTER_OVERLAY_RANDOM_POSITIONS_NORMAL;
        if(BenjiKIV.model.data.mode == BenjiKIVGameMode.FREESPIN) {
            moves = BenjiKIVStatics.SCATTER_OVERLAY_RANDOM_POSITIONS_FS;
        }
        for(let i:number = 0; i < moves; i++) {
            const moveTLs:gsap.core.Timeline[] = [];
            this._randomPositions = [];
            sweepSoundPlayed = false;
            for(let j:number = 0; j < this._activeOverlayScatters.length; j++) {
                const position:PIXI.Point = this.getRandomPosition();
                const moveTL:gsap.core.Timeline = gsap.timeline();
                if(sweepSoundPlayed == false) {
                    sweepSoundPlayed = true;
                    moveTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTI_SWEEP)});
                }
                moveTL.add([
                    gsap.to(this._activeOverlayScatters[j], this._randomAnimationDuration, {
                        x : position.x,
                        y : position.y
                    })
                ]);
                moveTLs.push(moveTL);
            }
            mainRandomTL.add(moveTLs);
        }

        return mainRandomTL;
    }

    private getRandomPosition():PIXI.Point {
        let randomPos:PIXI.Point = new PIXI.Point(MathHelper.randomIntInRange(0, 4) * BenjiKIVStatics.symbolWidth, (MathHelper.randomIntInRange(1, 3) + 1) * BenjiKIVStatics.symbolHeight);
        while(this.isPositionTaken(randomPos) == true) {
            randomPos = new PIXI.Point(MathHelper.randomIntInRange(0, 4) * BenjiKIVStatics.symbolWidth, (MathHelper.randomIntInRange(1, 3) + 1) * BenjiKIVStatics.symbolHeight);
        }
        this._randomPositions.push(randomPos);
        return randomPos;
    }

    //Check if random target position is already occupied
    private isPositionTaken(position:PIXI.Point):boolean {
        for(let i:number = 0; i < this._randomPositions.length; i++) {
            if(this._randomPositions[i].x == position.x && this._randomPositions[i].y == position.y) {
                return true;
            }
        }
        return false;
    }

    //If minimum random animation times are done but we have no server response, we keep on animating until we do
    public doNoEndRandomAnimation():void {
        this._noEndRandomAnimationTL = gsap.timeline({onComplete : () => this.checkNoEndToEnd()});
        const moveTLs:gsap.core.Timeline[] = [];
        this._randomPositions = [];
        let sweepSoundPlayed:boolean = false;
        for(let j:number = 0; j < this._activeOverlayScatters.length; j++) {
            const position:PIXI.Point = this.getRandomPosition();
            const moveTL:gsap.core.Timeline = gsap.timeline();
            if(sweepSoundPlayed == false) {
                sweepSoundPlayed = true;
                moveTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTI_SWEEP)});
            }
            moveTL.add(gsap.to(this._activeOverlayScatters[j], 0.4, {
                x : position.x,
                y : position.y
            }));
            moveTLs.push(moveTL);
        }
        this._noEndRandomAnimationTL.add(moveTLs);
    }

    private checkNoEndToEnd():void {
        if(this._stopNoEndAnimation == false) {
            this.doNoEndRandomAnimation();
        }
    }

    public getAnimateAllToTargetTL():gsap.core.Timeline {
        //Stop random animate timeline
        if(this._noEndRandomAnimationTL && this._noEndRandomAnimationTL.isActive()) {
            this._stopNoEndAnimation = true;
            this._noEndRandomAnimationTL.pause();
            this._noEndRandomAnimationTL.kill();
        }
        const mainToTargetTL:gsap.core.Timeline = gsap.timeline();
        const moveTLs:gsap.core.Timeline[] = [];
        let sweepSoundPlayed:boolean = false;
        for(let i:number = 0; i < this._activeOverlayScatters.length; i++) {
            const moveTL:gsap.core.Timeline = gsap.timeline();
            if(sweepSoundPlayed == false) {
                sweepSoundPlayed = true;
                moveTL.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTI_SWEEP)});
            }
            moveTL.add(gsap.to(this._activeOverlayScatters[i], this._randomAnimationDuration, {
                x : BenjiKIV.model.parsedTargetScatterPositions[i].x * BenjiKIVStatics.symbolWidth,
                y : (BenjiKIV.model.parsedTargetScatterPositions[i].y + 2) * BenjiKIVStatics.symbolHeight
            }));
            moveTL.add(() => {this._activeOverlayScatters[i].overlayPosition.x = BenjiKIV.model.parsedTargetScatterPositions[i].x});
            moveTL.add(() => {this._activeOverlayScatters[i].overlayPosition.y = BenjiKIV.model.parsedTargetScatterPositions[i].y + 2});
            moveTLs.push(moveTL);
        }
        mainToTargetTL.add(moveTLs);

        return mainToTargetTL;
    }

    public getAllOverlaysOnReel(reelId:number):BenjiKIVOverlayScatterSymbol[] {
        const overlaysOnReel:BenjiKIVOverlayScatterSymbol[] = [];
        for(let i:number = 0; i < this._activeOverlayScatters.length; i++) {
            if(this._activeOverlayScatters[i].overlayPosition.x == reelId) {
                overlaysOnReel.push(this._activeOverlayScatters[i]);
            }
        }
        return overlaysOnReel;
    }

    public getSetAllOverlaysToInitMultiplier(redXBet:boolean = false):gsap.core.Timeline {
        const setAllOverlaysToInitMultiplier:gsap.core.Timeline = gsap.timeline();
        if(redXBet == true) {
            let tempOverlayScatter:BenjiKIVOverlayScatterSymbol;
            if(this._activeOverlayScatters && this._activeOverlayScatters.length > 0) {
                while(this._activeOverlayScatters.length > 2) {
                    tempOverlayScatter = this._activeOverlayScatters.pop()!;
                    tempOverlayScatter.playOutAnimation(1);
                }
                this._activeOverlayScatters[0].isDead = false;
                this._activeOverlayScatters[1].isDead = false;
            }
        } else {
            setAllOverlaysToInitMultiplier.add(() => {BenjiKIV.soundPlayer.playSound(BenjiKIVSound.MULTI_DOWNGRADE)});
            if(this._activeOverlayScatters && this._activeOverlayScatters.length > 0) {
                const subTLs:gsap.core.Timeline[] = [];
                for(let i:number = 0; i < this._activeOverlayScatters.length; i++) {
                    subTLs.push(this._activeOverlayScatters[i].setToInitMultiplier());
                    subTLs.push(this._activeOverlayScatters[i].getARoomAnimation());
                }
                setAllOverlaysToInitMultiplier.add(subTLs);
            }
        }
        return setAllOverlaysToInitMultiplier;
    }

    public getHideAllOverlays(timeScale:number = 1):gsap.core.Timeline {
        const hideAllOverlaysTL:gsap.core.Timeline = gsap.timeline();
        if(this._activeOverlayScatters && this._activeOverlayScatters.length == 0) {
            return hideAllOverlaysTL;
        }
        let tempOverlayScatter:BenjiKIVOverlayScatterSymbol;
        hideAllOverlaysTL.add(() => {
            if(this._activeOverlayScatters && this._activeOverlayScatters.length > 0) {
                while(this._activeOverlayScatters.length > 0) {
                    tempOverlayScatter = this._activeOverlayScatters.pop()!;
                    tempOverlayScatter.playOutAnimation(timeScale);
                }
            }
        })
        return hideAllOverlaysTL;
    }

    get activeOverlayScatters():BenjiKIVOverlayScatterSymbol[] {
        return this._activeOverlayScatters;
    }
}